import { ERbacPermissions } from 'features/rbac/rbacPermissionsList';
import {
  LeftNavMenuKeysEnumCommon,
  LeftNavRoutesEnumCommon,
} from 'models/enums/commonRoutes/commonRoutes';
import {
  LeftNavMenuKeysEnumSb,
  LeftNavRoutesEnumSb,
} from 'models/enums/skyboxRoutes/skyboxRoutes';
import { IMenu } from 'models/interfaces';

export const initialMenuSb: IMenu[] = [
  {
    displayOrder: 1,
    menuTitle: 'Dashboard',
    iconClass: 'da icon-home',
    key: LeftNavMenuKeysEnumSb.DASHBOARD,
    child: [
      {
        menuTitle: 'Lister',
        key: LeftNavRoutesEnumSb.DASHBOARD_LISTER,
        navigationLink: LeftNavRoutesEnumSb.DASHBOARD_LISTER,
        show_in_mobile_view: true,
        allowed_permissions: [ERbacPermissions.LISTER_DASHBOARD_VIEW],
      },
      {
        menuTitle: 'Checker',
        key: LeftNavRoutesEnumSb.DASHBOARD_CHECKER,
        navigationLink: LeftNavRoutesEnumSb.DASHBOARD_CHECKER,
        show_in_mobile_view: true,
        allowed_permissions: [ERbacPermissions.CHECKER_DASHBOARD_VIEW],
      },
      {
        menuTitle: 'Seat Map Creator',
        key: LeftNavRoutesEnumSb.DASHBOARD_SEATMAPCREATOR,
        navigationLink: LeftNavRoutesEnumSb.DASHBOARD_SEATMAPCREATOR,
        show_in_mobile_view: true,
        allowed_permissions: [ERbacPermissions.SEATMAPCREATOR_DASHBOARD_VIEW],
      },
      {
        menuTitle: 'Operations',
        key: LeftNavRoutesEnumSb.DASHBOARD_OPERATIONS,
        navigationLink: LeftNavRoutesEnumSb.DASHBOARD_OPERATIONS,
        show_in_mobile_view: true,
        allowed_permissions: [ERbacPermissions.OPERATIONS_DASHBOARD_VIEW],
      },
      {
        menuTitle: 'Bot Performance',
        key: LeftNavRoutesEnumSb.DASHBOARD_BOT_PERFORMANCE,
        navigationLink: LeftNavRoutesEnumSb.DASHBOARD_BOT_PERFORMANCE,
        show_in_mobile_view: true,
        allowed_permissions: [ERbacPermissions.BOT_PERFORMANCE_DASHBOARD_VIEW],
      },
      {
        menuTitle: 'Performance Analysis',
        key: LeftNavRoutesEnumSb.DASHBOARD_PERFORMANCE_ANALYSIS,
        navigationLink: LeftNavRoutesEnumSb.DASHBOARD_PERFORMANCE_ANALYSIS,
        show_in_mobile_view: true,
        allowed_permissions: [
          ERbacPermissions.PERFORMANCE_ANALYSIS_DASHBOARD_VIEW,
        ],
      },
    ],
  },
  {
    displayOrder: 2,
    menuTitle: 'Zones',
    iconClass: 'da icon-zone',
    key: LeftNavMenuKeysEnumSb.ZONES,
    child: [
      {
        menuTitle: 'Zone Listings',
        key: LeftNavRoutesEnumSb.ZONES_LISTING,
        navigationLink: LeftNavRoutesEnumSb.ZONES_LISTING,
        show_in_mobile_view: true,
        allowed_permissions: [
          ERbacPermissions.VENUE_DETAILS_VIEW_ALL,
          ERbacPermissions.VENUE_DETAILS_VIEW_OWN,
          ERbacPermissions.VENUE_DETAILS_VIEW_TEAM,
        ],
      },
      {
        menuTitle: 'Pending Fills',
        key: LeftNavRoutesEnumSb.ZONES_PENDING_FILLS,
        navigationLink: LeftNavRoutesEnumSb.ZONES_PENDING_FILLS,
        show_in_mobile_view: true,
        allowed_permissions: [
          ERbacPermissions.ZONES_PENDING_ZONE_FILLS_VIEW_ALL,
          ERbacPermissions.ZONES_PENDING_ZONE_FILLS_VIEW_OWN,
        ],
      },
    ],
  },
  {
    displayOrder: 3,
    menuTitle: 'Trading',
    iconClass: 'da icon-event',
    key: LeftNavMenuKeysEnumSb.TRADING,
    child: [
      {
        menuTitle: 'Venues',
        key: LeftNavRoutesEnumSb.TRADING_VENUES,
        navigationLink: LeftNavRoutesEnumSb.TRADING_VENUES,
        show_in_mobile_view: true,
        allowed_permissions: [
          ERbacPermissions.VENUE_DETAILS_VIEW_ALL,
          ERbacPermissions.VENUE_DETAILS_VIEW_OWN,
          ERbacPermissions.VENUE_DETAILS_VIEW_TEAM,
        ],
      },
      {
        menuTitle: 'Events',
        key: LeftNavRoutesEnumSb.TRADING_EVENTS,
        navigationLink: LeftNavRoutesEnumSb.TRADING_EVENTS,
        show_in_mobile_view: true,
        allowed_permissions: [
          ERbacPermissions.EVENT_DETAILS_VIEW_ALL,
          ERbacPermissions.EVENT_DETAILS_VIEW_OWN,
          ERbacPermissions.EVENT_DETAILS_VIEW_TEAM,
        ],
      },
    ],
  },
  {
    displayOrder: 4,
    menuTitle: 'Purchases',
    iconClass: 'da icon-purchases',
    key: LeftNavMenuKeysEnumSb.PURCHASES,
    child: [
      {
        menuTitle: 'Purchase Queue',
        key: LeftNavRoutesEnumSb.PURCHASE_QUEUE,
        navigationLink: LeftNavRoutesEnumSb.PURCHASE_QUEUE,
        show_in_mobile_view: true,
        allowed_permissions: [
          ERbacPermissions.PURCHASE_QUEUE_VIEW_ALL,
          ERbacPermissions.PURCHASE_QUEUE_VIEW_TEAM,
          ERbacPermissions.PURCHASE_QUEUE_VIEW_OWN,
        ],
      },
    ],
  },
  {
    displayOrder: 4,
    menuTitle: 'Shipping',
    iconClass: 'da icon-shipping',
    key: LeftNavMenuKeysEnumSb.SHIPPING,
    child: [
      {
        menuTitle: 'Shipping Queue',
        key: LeftNavRoutesEnumSb.SHIPPING_QUEUE,
        navigationLink: LeftNavRoutesEnumSb.SHIPPING_QUEUE,
        show_in_mobile_view: true,
        allowed_permissions: [
          ERbacPermissions.SHIPPING_QUEUE_VIEW_ALL,
          ERbacPermissions.SHIPPING_QUEUE_VIEW_TEAM,
          ERbacPermissions.SHIPPING_QUEUE_VIEW_OWN,
        ],
      },
      {
        menuTitle: 'Delivered Tickets',
        key: LeftNavRoutesEnumSb.DELIVERED_TICKETS_REPORT,
        navigationLink: LeftNavRoutesEnumSb.DELIVERED_TICKETS_REPORT,
        show_in_mobile_view: true,
        allowed_permissions: [
          ERbacPermissions.REPORT_DELIVERED_TICKETS_VIEW_ALL,
        ],
      },
    ],
  },
  {
    displayOrder: 6,
    menuTitle: 'Housekeeping',
    iconClass: 'da icon-housekeeping',
    key: LeftNavMenuKeysEnumSb.HOUSEKEEPING,
    child: [
      // {
      //   menuTitle: "Event Mapping",
      //   key: LeftNavRoutesEnumSb.HOUSEKEEPING_EVENT_MAPPING,
      //   navigationLink: LeftNavRoutesEnumSb.HOUSEKEEPING_EVENT_MAPPING,
      //   show_in_mobile_view: false,
      //   allowed_permissions: [
      //     ERbacPermissions.HOUSEKEEPING_EVENT_MAPPING_VIEW_ALL,
      //     ERbacPermissions.HOUSEKEEPING_EVENT_MAPPING_VIEW_TEAM,
      //     ERbacPermissions.HOUSEKEEPING_EVENT_MAPPING_VIEW_OWN,
      //   ],
      // },
      {
        menuTitle: 'Cancelled Shows',
        key: LeftNavRoutesEnumSb.HOUSEKEEPING_CANCELLED_SHOWS,
        navigationLink: LeftNavRoutesEnumSb.HOUSEKEEPING_CANCELLED_SHOWS,
        show_in_mobile_view: false,
        allowed_permissions: [
          ERbacPermissions.HOUSEKEEPING_INVENTORY_ACTIVE_VIEW_ALL,
          ERbacPermissions.HOUSEKEEPING_INVENTORY_ACTIVE_VIEW_OWN,
          ERbacPermissions.HOUSEKEEPING_INVENTORY_ACTIVE_VIEW_TEAM,
          ERbacPermissions.HOUSEKEEPING_INVENTORY_SOLD_VIEW_ALL,
          ERbacPermissions.HOUSEKEEPING_INVENTORY_SOLD_VIEW_OWN,
          ERbacPermissions.HOUSEKEEPING_INVENTORY_SOLD_VIEW_TEAM,
          ERbacPermissions.HOUSEKEEPING_UNFILLED_ZONES_VIEW_ALL,
          ERbacPermissions.HOUSEKEEPING_UNFILLED_ZONES_VIEW_TEAM,
          ERbacPermissions.HOUSEKEEPING_UNFILLED_ZONES_VIEW_OWN,
          ERbacPermissions.HOUSEKEEPING_CANCELLED_INVENTORY_VIEW_ALL,
          ERbacPermissions.HOUSEKEEPING_CANCELLED_INVENTORY_VIEW_TEAM,
          ERbacPermissions.HOUSEKEEPING_CANCELLED_INVENTORY_VIEW_OWN,
        ],
      },
    ],
  },
  {
    displayOrder: 8,
    menuTitle: 'Insights',
    iconClass: 'da icon-report',
    key: LeftNavMenuKeysEnumSb.INSIGHTS,
    child: [
      {
        menuTitle: 'Reports',
        key: LeftNavRoutesEnumSb.INSIGHTS_REPORTS,
        navigationLink: LeftNavRoutesEnumSb.INSIGHTS_REPORTS,
        show_in_mobile_view: true,
        allowed_permissions: [ERbacPermissions.REPORT_DASHBOARD_VIEW],
      },
      {
        menuTitle: 'Schedules',
        key: LeftNavRoutesEnumSb.INSIGHTS_SCHEDULES,
        navigationLink: LeftNavRoutesEnumSb.INSIGHTS_SCHEDULES,
        show_in_mobile_view: true,
        allowed_permissions: [
          ERbacPermissions.SCHEDULES_VIEW_ALL,
          ERbacPermissions.SCHEDULES_VIEW_OWN,
          ERbacPermissions.SCHEDULES_VIEW_TEAM,
        ],
      },
    ],
  },
  {
    displayOrder: 9,
    menuTitle: 'Settings',
    iconClass: 'da icon-settings',
    key: LeftNavMenuKeysEnumCommon.SETTINGS,
    child: [
      {
        menuTitle: 'Users',
        key: LeftNavRoutesEnumCommon.SETTINGS_USERS,
        navigationLink: LeftNavRoutesEnumCommon.SETTINGS_USERS,
        show_in_mobile_view: true,
        allowed_permissions: [
          ERbacPermissions.USER_DETAILS_VIEW_ALL,
          ERbacPermissions.USER_DETAILS_VIEW_OWN,
          ERbacPermissions.USER_DETAILS_VIEW_TEAM,
        ],
      },
      {
        menuTitle: 'Commissions',
        key: LeftNavRoutesEnumCommon.SETTINGS_COMMISSIONS,
        navigationLink: LeftNavRoutesEnumCommon.SETTINGS_COMMISSIONS,
        show_in_mobile_view: true,
        allowed_permissions: [ERbacPermissions.SETTINGS_COMMISSIONS_VIEW],
      },
      {
        menuTitle: 'Dynamic Pricing',
        key: LeftNavRoutesEnumCommon.SETTINGS_DYNAMIC_PRICING,
        navigationLink: LeftNavRoutesEnumCommon.SETTINGS_DYNAMIC_PRICING,
        show_in_mobile_view: true,
        allowed_permissions: [
          ERbacPermissions.DYNAMIC_PRICING_RULES_VIEW_ALL,
          ERbacPermissions.DYNAMIC_PRICING_RULES_VIEW_TEAM,
          ERbacPermissions.DYNAMIC_PRICING_RULES_VIEW_OWN,
        ],
      },
    ],
  },
];
